module.exports = __webpack_public_path__ + "static/media/371.5372c900.svg";